import { Component, ViewChild, ElementRef } from '@angular/core';
import { ShopService } from './services/shop.service';
import { LoaderService } from './services/loader.service';
import { MessageService } from './services/message.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { firstValueFrom } from 'rxjs';


@Component({
    selector: 'my-helpdesktickets',
    templateUrl: '/helpdesktickets.html?'

})

export class HelpDeskTicketsComponent {

    subscriptions: Subscription[] = []
  myData: any = [];

    myDataOpen: any = [];
    myDataClosed: any = [];
    myDataAll: any;
    myDataShop: any;
    myDataHelp: any;
    myTicket: any;
    myfilter: string = "All Issues";
  shopKey: string;
  sla: string = "";
  dspSla = false;
  doHelpDesk = false;
  dsp = "";
    constructor(private shopservice: ShopService
        , private loaderService: LoaderService
      , public http: HttpClient
        , public messageService: MessageService
        , private cdr: ChangeDetectorRef) {
    }


    myKey: number = 0;



 myType: any  =    [{ Type: "Non Collection", Problem: "Not Collected" }
   , { Type: "Non Delivery", Problem: "Not Received" }
   , { Type: "Missing Delivery", Problem: "Missing Delivery" } 
    , { Type: "Missing Item In Parcel", Problem: "Missing Items" }
    , { Type: "Damaged Item In Parcel", Problem: "Damaged Item In Parcel" }
    , { Type: "Damaged Parcel", Problem: "Damaged Parcel" }
    , { Type: "Delivery Access Amendment", Problem: "Delivery Access Amendment" }
    , { Type: "Site Address Change", Problem: "Site Address Change" }
    , { Type: "General Query", Problem: "General Query" }

  ];

  formatType(str: string) {

    let Type = str?.trim().replace(/^Opticians\//, "");
    let match = this.myType.find(
      (itm: any) => itm.Problem?.toLowerCase() === Type?.toLowerCase()
    );

    return match ? match.Type : str;
  }


  cleanIncludes(str: string) {

    return str.replace(/(\r\n|\n|\r)/g, '<br>');
        //return str
       // return str.replace(/\(Includes\s.*?\)/, "").trim();
    }

    isTextTruncated(element: any) {
      return element.scrollWidth > element.clientWidth;
  }
  doPopUp = false;
  caseNum = "";
  caseId = "";
  shopId = "";
  reply(caseNum: string, caseId: string) {
    this.caseNum = caseNum
    this.caseId = caseId
    this.shopId = this.shopservice.shop
    this.doPopUp = true;
    

  }

  
    isData(itm: any): string[] {
        if (Array.isArray(JSON.parse(itm))) {
                return JSON.parse(itm);
            } else {
                return null;
            }
        }


    async getTickets(shop: string): Promise<any> {
        this.loaderService.emitChange(true); // Emit loader status
        const myUrl = `/HelpDeskArez/GetShopTickets/${shop}`;
        try {
          const response = await firstValueFrom(this.http.get<any>(myUrl));

          this.loaderService.emitChange(false); // Stop loader
          return response; // Return the parsed JSON object
        } catch (error) {
          this.loaderService.emitChange(false); // Stop loader on error
          this.messageService.emitChange({ Css: "error", Message: "Error fetching help desk tickets " + error });
          throw error; // Propagate the error
        }
      


  }

  async recentlyAdded(shop: string): Promise<any> {
    this.loaderService.emitChange(true); // Emit loader status
    const myUrl = `/HelpDeskTickets/HelpDeskGet/${shop}`;
    try {
      const response = await firstValueFrom(this.http.get<any>(myUrl));
      this.loaderService.emitChange(false); // Stop loader
      return response; // Return the parsed JSON object
    } catch (error) {
      this.loaderService.emitChange(false); // Stop loader on error
      this.messageService.emitChange({ Css: "error", Message: "Error fetching help desk tickets " + error });
      throw error; // Propagate the error
    }
  }

  async recentReplys(shop: string): Promise<any> {
    this.loaderService.emitChange(true); // Emit loader status
    const myUrl = `/HelpDeskTickets/HelpDeskReplyGet/${shop}`;
    try {
      const response = await firstValueFrom(this.http.get<any>(myUrl));
      this.loaderService.emitChange(false); // Stop loader
      return response; // Return the parsed JSON object
    } catch (error) {
      this.loaderService.emitChange(false); // Stop loader on error
      this.messageService.emitChange({ Css: "error", Message: "Error fetching help desk tickets " + error });
      throw error; // Propagate the error
    }
  }
  
   

    async updateJobs(shop: string): Promise<any> {
        this.loaderService.emitChange(true); // Emit loader status
        const myUrl = `/HelpDeskArez/GetShopJobs/${shop}`;

        try {
          const response = await firstValueFrom(this.http.get<any>(myUrl)); //await this.http.get(myUrl).toPromise(); // Use toPromise for async/await
            this.loaderService.emitChange(false); // Stop loader
            return response; // Return the fetched data
        } catch (error) {
            this.loaderService.emitChange(false); // Stop loader on error
            this.messageService.emitChange({ "Css": "error", "Message": "Error fetching help desk requests " + error });
            throw error; // Propagate the error
        }
    }


    async getJob(jobid: string): Promise<any> {
        this.loaderService.emitChange(true); // Emit loader status
        const myUrl = `/HelpDeskArez/GetTicket/${jobid}`;

        try {
          const response = await firstValueFrom(this.http.get<any>(myUrl)); //await this.http.get(myUrl).toPromise(); // Use toPromise for async/await
            this.loaderService.emitChange(false); // Stop loader
            return response; // Return the fetched data
        } catch (error) {
            this.loaderService.emitChange(false); // Stop loader on error
            this.messageService.emitChange({ "Css": "error", "Message": "Error fetching help desk requests " + error });
            throw error; // Propagate the error
        }
    }



    async reload() {
        await this.load()
    }

  dspskeleton = true;
  myDataNew: any = [];
  myDataNewTickets: any = [];
  myDataNewReplys: any = [];
    async load() {
      try {

            this.dspskeleton = false;

          //AREZ TODO uncommment if getting additinal data form Arez
          //await this.updateJobs(this.shopKey);
          //AREZ TODO

        this.myDataNewTickets = await this.recentlyAdded(this.shopservice.shop);
        this.myDataNewReplys = await this.recentReplys(this.shopservice.shop);

    
        if (!this.myDataNewTickets?.length || this.myDataNewTickets[0]?.error) {
          this.myDataNew = [];
        } else {
          this.myDataNew = JSON.parse(JSON.stringify(this.myDataNewTickets));
        }


        

        this.myData = await this.getTickets(this.shopservice.shop);

       
        if (!this.myData?.length || this.myData[0]?.error) {
                this.myDataAll = []
                this.myDataClosed = []
                this.myDataOpen = []
            }
            else {
                this.myDataAll = JSON.parse(JSON.stringify(this.myData));
                this.myDataClosed = this.myDataAll.filter((itm: any) => itm.Status == 'Closed');
                this.myDataOpen = this.myDataAll.filter((itm: any) => itm.Status != 'Closed');
        }

        //console.log(this.myDataNew)
        //console.log(this.myData)
        //if (!this.myData[0]?.error){
        //    this.myDataNew = this.myDataNew.filter(a => !this.myData.some(b => b.CaseNum === a.CaseNum) );
        //}

        const isEmpty = this.myData.length === 0;
        const hasError = this.myData.some(x => x.error);

        if (!isEmpty && !hasError) {
          const caseNums = new Set(this.myData.map(x => x.CaseNum));
          this.myDataNew = this.myDataNew.filter(a => !caseNums.has(a.CaseNum));
        }


        //this.myDataNew.forEach()
        this.myDataOpen.forEach(itmDataOpen => {
          this.myDataNewReplys.forEach(itmNewReplys => {

       
            if (itmDataOpen.CaseNum * 1 === itmNewReplys.CaseNum * 1) {

              if (!Array.isArray(itmDataOpen.CaseUpdates)) {
                itmDataOpen.CaseUpdates = [];
              }

        
              const exists = itmDataOpen.CaseUpdates.some(
                cu => cu.CaseUpdateId === itmNewReplys.CaseUpdateId
              );

              if (!exists) {
                itmDataOpen.CaseUpdates.push(itmNewReplys);
              }
            }
          });
        });

        this.myDataNew.forEach(itmDataNew => {
          this.myDataNewReplys.forEach(itmNewReplys => {

       
            if (itmDataNew.CaseNum * 1 === itmNewReplys.CaseNum * 1) {

              if (!Array.isArray(itmDataNew.CaseUpdates)) {
                itmDataNew.CaseUpdates = [];
              }


              const exists = itmDataNew.CaseUpdates.some(
                cu => cu.CaseUpdateId === itmNewReplys.CaseUpdateId
              );

              if (!exists) {
                itmDataNew.CaseUpdates.push(itmNewReplys);
              }
            }
          });
        });

        } catch (error) {
            this.messageService.emitChange({ "Css": "error", "Message": "Failed to load Help Desk Requests " + error });
        }
    }


    myJob: any = [];



  retry(id: any) {

 
      this.loaderService.emitChange(true);
      let mySubmissionData = {
        "Id": id
      }

    this.http.post<any>("/HelpDesk/Retry", mySubmissionData)
        .subscribe({
          next: (res) => {
            this.loaderService.emitChange(false);

            try {
              if (res.Result !== "success") {
                if (res.Message) {
                  this.messageService.emitChange({ "Css": "error", "Message": res.Message });
                } else {
                  this.messageService.emitChange({ "Css": "error", "Message": res[0]?.message });
                }

              } else {
    
                this.messageService.emitChange({ "Css": "success", "Message": res.Message });
                this.load()


              }
            } catch (e) {
              this.messageService.emitChange({ "Css": "error", "Message": res + "." });
            }
          },
          error: (error) => {
            this.messageService.emitChange({ "Css": "error", "Message": error + "." });
          }
        });



  }
   
    async ngOnInit(): Promise<void> {

      // Load initial data
      this.myDataShop = this.shopservice.getShopFromStorage();
      this.updateShopFields();

      // React to changes
      this.subscriptions.push(this.shopservice.changeShop$.subscribe(shop => {
          this.myDataShop = shop;
          this.updateShopFields();
        })
      );

      this.load();
  }

  doPopUpClaimsForms = false;
  claimsForms() {
    this.doPopUpClaimsForms = true;

  }

    private updateShopFields(): void {
      this.shopKey = this.myDataShop?.Store ?? null;
      this.sla = this.myDataShop?.Sla ?? "N/A";
      this.dspSla = !!this.myDataShop;
    }

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
    }

}
